export default "__VITE_ASSET__Bq7txx9Q__"